import React, { useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { getSocket } from "../utils/socket";

const ChatTabs = ({ unreadCount, onTabChange }) => {
  const { token } = useAuth(); // Chỉ lấy token, không cần authUser

  // Khởi tạo socket và lắng nghe sự kiện
  useEffect(() => {
    if (token) {
      const socket = getSocket();
      if (!socket.connected) {
        socket.connect();
      }

      const handleUpdateChatList = (data) => {
        console.log("Cập nhật danh sách chat:", data);
        onTabChange();
      };

      socket.on("updateChatList", handleUpdateChatList);

      return () => {
        socket.off("updateChatList", handleUpdateChatList);
      };
    }
  }, [token, onTabChange]);

  return (
    <div className="bg-white shadow-md p-4">
      <div className="flex space-x-4">
        <button className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600">
          Tin nhắn ({unreadCount})
        </button>
        <button className="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300">
          Bạn bè
        </button>
        <button className="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300">
          Thông báo
        </button>
      </div>
    </div>
  );
};

export default ChatTabs;